import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import AuthCallbackPage from '../pages/AuthCallback';
import { MainPage } from '../pages/Main';
import RenewCallbackPage from '../pages/RenewCallback';

import { mainPageRoutes } from './mainPageRoutes';

export const routes: RouteObject[] = [
  {
    path: '/auth/callback/keycloak',
    element: <AuthCallbackPage />,
  },
  {
    path: '/auth/callback/keycloak-silent',
    element: <RenewCallbackPage />,
  },
  {
    path: '/',
    element: <MainPage />,
    children: [mainPageRoutes],
  },
  {
    path: '*',
    element: <Navigate to="/content-unavailable" replace />,
  },
];
